import { render, staticRenderFns } from "./customerClues.vue?vue&type=template&id=0ebba41f&"
import script from "./customerClues.vue?vue&type=script&lang=js&"
export * from "./customerClues.vue?vue&type=script&lang=js&"
import style0 from "./customerClues.vue?vue&type=style&index=0&id=0ebba41f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports